// <auto-submit> — wraps a form and submits it whenever a control inside
// changes. Used by the settings toggles so flipping a switch saves itself;
// without JavaScript the form's (visually present) submit button still works.
//
//   <auto-submit>
//     <form ...> <input type="checkbox" ...> <button class="js:hidden">Save</button> </form>
//   </auto-submit>

class AutoSubmit extends HTMLElement {
	connectedCallback() {
		this.addEventListener("change", () => {
			this.querySelector("form")?.requestSubmit();
		});
		// JS is here: the fallback submit button is redundant chrome.
		for (const el of this.querySelectorAll("[data-auto-submit-fallback]")) {
			el.classList.add("hidden");
		}
	}
}

if (!customElements.get("auto-submit")) {
	customElements.define("auto-submit", AutoSubmit);
}
